import { observer } from 'mobx-react-lite';
import { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '~/app/app.routes';
import { AuthService } from '~/service/service.auth';
import { useService } from '~/shared/service/service.base';
import { GridContainer } from '~/view/grid/grid.container';
import { IconLogo } from '~/view/icons/icon.logo';
import { Col, Text } from '~/view/view.box';

export const IndexPage = observer(() => {
	const [auth] = useService(AuthService);
	const nav = useNavigate();

	useLayoutEffect(() => {
		if (auth.can('analytics', 'READ')) nav(AppRoutes.DashboardGeneral.path);
	}, [auth, nav]);

	return (
		<GridContainer async={auth.async}>
			<Col flex={1} gap={4} alignItems="center" justifyContent="center">
				<IconLogo />
				<Text variant="subtitle1" color="text.primary">
					Please select a page from the menu
				</Text>
				<Text color="text.secondary">
					If you don't have access to a specific page, contact your administrator
				</Text>
			</Col>
		</GridContainer>
	);
});
